import FullHeightDragable from "./FullHeightDragable";
import Measurer from "../interaction/Measurer";

export default class HeightDragHandle extends THREE.Group {

    height = 20;
    depth = 4;
    owner: FullHeightDragable;
    border: Symbol;
    dragLock = false;

    constructor(owner, border) {
        super();
        this.hoverable = true;
        this.draggable = true;
        this.owner = owner;
        this.border = border;

        // Das Handle ist so gebaut, dass die Maus in der Mitte liegt und die Mitte genau auf dem Rand der Tür-Box
        // Die eine Hälfte (ChildBox) ist sichtbar und die andere unsichtbar
        this.add(this.createChildBox());
        this.add(this.createChildBox());
        this.children[0].position.set(0, -this.height / 4, 0);
        this.children[1].position.set(0, +this.height / 4, 0);
        this.visible = false;
    }

    createChildBox(material) {
        const a = new THREE.Mesh();
        a.material = new THREE.MeshBasicMaterial({color: 0x93b4ed, opacity: 0.3, transparent: true});
        a.geometry = new THREE.BoxGeometry(1, this.height / 2, 1);
        a.material.visible = false;
        a.visible = false;
        return a;
    }

    show(on) {
        const i = this.border === Measurer.TOP ? 0 : 1;
        this.children[i].material.visible = on;
        this.children.forEach(c => c.visible = on);
        this.visible = on;
    }

    vsUpdate() {
        const box = this.vsData.boxLocal.clone();
        box.min.z = this.vsData.frontBox.max.z;
        box.max.z = box.min.z + this.depth;

        if (this.border === Measurer.TOP) {
            box.max.y += this.height / 2;
            box.min.y = box.max.y - this.height;
        } else {
            box.min.y -= this.height / 2;
            box.max.y = box.min.y + this.height;
        }
        if (!this.dragging) {
            this.position.copy(box.getCenter());
        }
        if (this.owner.isVsChanged('size')) {
            const size = box.getSize();
            size.y = 1;
            this.scale.copy(size);
        }
    }

    onDrag() {
        if (this.dragLock) {
            return;
        }
        const box = this.vsData.box.clone();
        const y = this.vsData.localToSchrank(this.position).y;

        if (this.border === Measurer.TOP) {
            box.max.y = y;
        } else {
            box.min.y = y;
        }

        this.vsData.position.copy(box.getCenter());
        this.vsData.size.copy(box.getSize());
        APP.model.setDirty();
    }

    onChangeInDragSelectHoverState() {
        this.show((this.hovering || this.owner.hovering) && !(this.dragging || this.owner.dragging));
        STAGE.dirty();
    }

    get vsData() {
        return this.owner.vsData;
    }

}
